<template>
    <div class="personal-detail-form">
        <b-form role="form" class="mt-4">
            <b-row>
                <b-col cols="8" lg="7">
                    <b-form-group label="Investor Name">
                        <b-form-input v-model="form.name" type="text"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="8" lg="7">
                    <b-form-group label="Investor Name">
                        <b-form-input v-model="form.nric" type="text"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="8" lg="7">
                    <b-form-group label="Contact No.">
                        <b-form-input v-model="form.contact_no" type="text"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="8" lg="7">
                    <b-form-group label="Email Address">
                        <b-form-input v-model="form.address" type="text"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" lg="7">
                    <b-row>
                        <b-col cols="12" md="4">
                            <b-form-group label="State">
                                <b-form-input v-model="form.state" type="text"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-group label="City">
                                <b-form-input v-model="form.state" type="text"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-group label="Postcode">
                                <b-form-input v-model="form.postcode" type="text"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="12" lg="7">
                    <b-form-group label="Marital Status">
                        <b-form-radio-group
                            v-model="form.marital_status"
                            :options="maritalStsOpt"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" lg="7">
                    <b-form-group label="Race">
                        <el-radio-group v-model="form.race" fill="#13663E">
                            <el-radio-button label="Chinese"></el-radio-button>
                            <el-radio-button label="Malay"></el-radio-button>
                            <el-radio-button label="Indian"></el-radio-button>
                            <el-radio-button label="Others"></el-radio-button>
                        </el-radio-group>
                    </b-form-group>
                </b-col>

                <b-col cols="7">
                    <b-button block variant="primary" class="w-50">Save</b-button>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>
<script>
import { Button, RadioButton, RadioGroup } from 'element-ui'

export default {
    components: {
        [Button.name]: Button,
        [RadioButton.name]: RadioButton,
        [RadioGroup.name]: RadioGroup,
    },
    data() {
        return {
            form: {
                name: '',
                nric: '',
                contact_no: '',
                email: '',
                address: '',
                state: '',
                city: '',
                postcode: '',
                marital_status: '',
                race: ''
            },
            maritalStsOpt: [
                { text: 'Single', value: 'single' },
                { text: 'Married', value: 'married' }
            ]
        }
    }
}
</script>